// extracted by mini-css-extract-plugin
export default {"ScrollDownArrow":"ScrollDownArrow_ScrollDownArrow__7OhL+"};